<template>
    <app-admin-layout>
        <Head>
            <title>Admin User</title>
        </Head>
        <form @submit.prevent="submit">
            <div class="admin-user">
                <div class="container">
                    <div class="row">
                        <div class="col col-6">
                            <card>
                                <card-header>
                                    <card-overline>Benutzer</card-overline>
                                </card-header>
                                <card-content>
                                    <form-input id="name" label="Name" v-model="form.name"
                                                :error="form.errors.name"/>
                                    <form-input id="comment" label="Beschreibung" v-model="form.comment"
                                                :error="form.errors.comment"/>
                                </card-content>
                            </card>
                        </div>
                        <div class="col col-6">
                            <card>
                                <card-header>
                                    <card-overline>Account</card-overline>
                                </card-header>
                                <card-content>
                                    <div class="row">
                                        <div class="col">
                                            <form-input id="email" label="Email" v-model="form.email"
                                                        :error="form.errors.email"/>

                                            <form-select id="admin_user_group" label="Benutzergruppe"
                                                        v-model="form.admin_user_group" :options="adminUserGroupOptions"
                                                        :error="form.errors.admin_user_group"/>
                                        </div>
                                    </div>
                                    <div class="row" v-if="this.adminUser">
                                        <div class="col col-6">
                                            <form-button type="button" color="secondary" class="btn--block"
                                                         icon="button-arrow-right-circle"
                                                         @click="resetPassword">Passwort zurücksetzen
                                            </form-button>
                                        </div>
                                        <div class="col col-6">
                                            <form-button type="button" color="error" class="btn--block"
                                                         v-if="this.adminUser?.active"
                                                         icon="button-arrow-right-circle"
                                                         @click="disableAdmin">
                                                Account deaktivieren
                                            </form-button>
                                            <form-button type="button" color="secondary" class="btn--block"
                                                         v-if="!this.adminUser?.active"
                                                         icon="button-arrow-right-circle"
                                                         @click="disableAdmin">
                                                Account aktivieren
                                            </form-button>
                                        </div>
                                    </div>

                                </card-content>
                            </card>
                        </div>
                    </div>
                    <div class="row" v-sticky>
                        <div class="col">
                            <form-actions>
                                <form-button type="submit" color="secondary"
                                             icon="button-arrow-right-circle"
                                             class="btn--block" :disabled="form.processing" :class="{'btn--processing': form.processing}">
                                    Speichern
                                </form-button>
                            </form-actions>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import {useForm} from '@inertiajs/vue3';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormActions from '@partfactory/Shared/Form/FormActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormSelect from '@partfactory/Shared/Form/FormSelect';

export default {
    name: 'AdminUserForm',
    components: {
        FormSelect,
        FormButton, FormActions, FormInput, CardContent, CardOverline, CardHeader, Card, AppAdminLayout
    },
    props: {
        adminUser: Object,
    },
    data() {
        const form = useForm({
            name: this.adminUser?.name ? this.adminUser?.name : null,
            email: this.adminUser?.email ? this.adminUser?.email : null,
            comment: this.adminUser?.comment ? this.adminUser?.comment : null,
            password: this.adminUser?.password ? this.adminUser?.password : null,
            active: this.adminUser?.active ? this.adminUser?.active : null,
            admin_user_group: this.adminUser?.admin_user_group ? this.adminUser?.admin_user_group : null,
        });

        return {form};
    },
    computed: {
        adminUserGroupOptions() {
            return this.$page.props.adminUserGroups;
        },
    },
    methods: {
        submit() {
            console.log(this?.adminUser?.id);
            if (this?.adminUser?.id) {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .patch(this.$$route('admin-user.update', {'adminUser': this.adminUser.id}), {});
            } else {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                    }))
                    .post(this.$$route('admin-user.store'), {});
            }
        },
        resetPassword() {
            this.$inertia.post(this.$$route('admin-user.invite', {'adminUser': this.adminUser.id}));
        },
        disableAdmin() {
            this.$inertia.patch(this.$$route('admin-user.disable', {'adminUser': this.adminUser.id}));
        },
    },
};
</script>
